import {
  PremiumSessionAggregate,
  PremiumSessionUserFacingStatus,
} from 'types/premiumSession';
import { useMemo } from 'react';
import useMobxStores from './useMobxStores';

export default function usePremiumSessionAggregateInfo({
  premiumSessionAggregate,
}: {
  premiumSessionAggregate: PremiumSessionAggregate;
  ignorePastSessions?: boolean;
}) {
  const { classesStore, premiumSessionsStore } = useMobxStores();

  const { extraSessionInfoMap, sessionsStatusList } = useMemo(() => {
    if (!premiumSessionAggregate) {
      return {
        extraSessionInfoMap: new Map(),
        sessionsStatusList: [] as Array<{
          slug: string;
          status: PremiumSessionUserFacingStatus;
        }>,
      };
    }

    return premiumSessionsStore.buildPremiumSessionAggregateInfo(
      premiumSessionAggregate,
    );
  }, [
    classesStore.getInterestInSession,
    premiumSessionAggregate,
    premiumSessionsStore,
  ]);

  const hasSessionProgress = useMemo(
    () =>
      sessionsStatusList.some(
        (sessionStatus) =>
          sessionStatus.status !== PremiumSessionUserFacingStatus.Unavailable &&
          sessionStatus.status !== PremiumSessionUserFacingStatus.Schedulable,
      ),
    [sessionsStatusList],
  );

  return { extraSessionInfoMap, hasSessionProgress, sessionsStatusList };
}
